import * as ng from 'angular';
import { PK } from 'commons';
import { TradersYardApi } from '../../models/api';

function getCheckoutWindowOptions(width: number, height: number) {
    const topPos = window.screenTop;
    const leftPos = window.screenLeft + window.innerWidth / 2 - width;
    return `width=${width},height=${height},top=${topPos},left=${leftPos},toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no`;
}

const CHECKOUT_WINDOW_TARGET = 'tradersyard-checkout';

export const GroupCheckoutModalComponent: ng.IComponentOptions = {
    bindings: {
        close: '&',
        dismiss: '&',
        modalInstance: '=',
        resolve: '<',
    },
    template: require('./group-checkout-modal.html').default,
    controller: class GroupCheckoutModalComponent implements ng.IComponentController {
        static $inject = ['$http', '$window', '$timeout', '$socket'];
        constructor(
            private $http: ng.IHttpService,
            private $window: ng.IWindowService,
            private $timeout: ng.ITimeoutService,
            private $socket: any
        ) {}

        private resolve: {
            groupId?: string;
            joinRequestId?: string;
            subscriptionPlan?: TradersYardApi.Groups.GroupSubscriptionPlan[];
        } = {};
        private order?: TradersYardApi.xYards.xYardsOrder = undefined;

        /**
         * Handle to checkout popup window. We want to close it when order is paid.
         * @private
         */
        private checkoutWindow: Window | null = null;

        /**
         * Different views we can show in the modal. Kind of a router :)
         * @private
         */
        private view: 'checkout' | 'pending' | 'success' = 'checkout';

        /**
         * Flag indicating if we are waiting for some request to finish.
         * @private
         */
        private isLoading = false;

        /**
         * Subscription plan that the user will be paying for. Not used atm.
         * @private
         */
        private subscriptionPlan?: TradersYardApi.Groups.GroupSubscriptionPlan;

        $onInit() {
            this.$socket.on('xy:order.status_change', (socketData: { order_key: string; status: string }) => {
                // skip orders that we are not interested about
                // TODO: make sure we only receive events for the current user
                if (this.order?.ty_order_key !== socketData.order_key) return;

                this.order.status = socketData.status as TradersYardApi.xYards.xYardsOrderStatus;

                if (this._isOrderPaid(socketData)) {
                    this.view = 'success';
                    this.checkoutWindow?.close();

                    this.$timeout(() => {
                        // when order is paid, reload the page after moment. The user should now be part of the group.
                        window.location.reload();
                    }, 2000);
                }
            });

            if (this.resolve.subscriptionPlan) {
                this.subscriptionPlan = this.resolve.subscriptionPlan[0];
            }
        }

        focusCheckoutWindow() {
            const checkoutClosed = this.checkoutWindow?.closed ?? true;

            if (!checkoutClosed) {
                // if window is not closed, just try to focus it.
                this.checkoutWindow?.focus();
            } else if (this.order) {
                // the window might be closed, but we might have the order details, so just open the checkout page
                this._openCheckoutUrl(this.order);
            } else {
                // should no happen, but yeah... no order was found, just go back to checkout view
                this.view = 'checkout';
            }
        }

        openCheckout = () => {
            const { groupId, joinRequestId } = this.resolve;

            if (this.order) {
                console.warn('Existing order is present. Just open checkout URL.');
                this._openCheckoutUrl(this.order);
                return;
            }

            if (!groupId || !joinRequestId) {
                console.warn('Group or Join Request missing', groupId, joinRequestId);
                return;
            }

            this.isLoading = true;
            this._startCheckout(groupId, joinRequestId)
                .then((orderData) => {
                    this.order = orderData;
                    this._openCheckoutUrl(orderData);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        };

        private _openCheckoutUrl(order: TradersYardApi.xYards.xYardsOrder) {
            const windowOptions = getCheckoutWindowOptions(800, 1000);
            this.checkoutWindow = this.$window.open(order.checkout_url, CHECKOUT_WINDOW_TARGET, windowOptions);
            this.view = 'pending';
        }

        private _startCheckout(groupId: PK, requestId: PK): ng.IPromise<TradersYardApi.xYards.xYardsOrder> {
            return this.$http
                .post<{ data: TradersYardApi.xYards.xYardsOrder }>(
                    `/api/v1.0/group/${groupId}/request/${requestId}/checkout`,
                    {}
                )
                .then((res) => res.data.data);
        }

        private _isOrderPaid(remoteOrder: { status: string }): boolean {
            return [
                TradersYardApi.xYards.xYardsOrderStatus.PROCESSING,
                TradersYardApi.xYards.xYardsOrderStatus.COMPLETED,
            ].includes(remoteOrder.status as TradersYardApi.xYards.xYardsOrderStatus);
        }
    },
};
